import script from "./usb-guard.vue?vue&type=script&setup=true&lang=ts"
export * from "./usb-guard.vue?vue&type=script&setup=true&lang=ts"

import "./usb-guard.vue?vue&type=style&index=0&id=e41592e4&lang=scss&scoped=true"

import exportComponent from "/data/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e41592e4"]])

export default __exports__